<template>
  <div class="root small-banner">
    <v-container :class="{ fixed: isDesktop }">
      <div class="slider-wrap">
        <div class="text">
          <slot>
            <h3 class="use-text-title">
              <span v-t="'Amazing acompany deserve'" />
              <strong>
                <span v-t="'amazing software'" />
              </strong>
            </h3>
            <p class="use-text-subtitle">
              <span v-t="'Millions of happy users work better with our integrated Apps.'" />
            </p>
          </slot>
          <div class="btn-area">
            <v-btn :to="link.saas.register" color="secondary" large>
              <span v-t="'Get Started'" />
            </v-btn>
          </div>
        </div>
        <div class="illustration">
          <!-- <img :src="imgAPI.saas[7]" alt="illustration" /> -->
          <img :src="imgAPI.saas[8]" alt="illustration" />
        </div>
      </div>
    </v-container>
    <div class="deco">
      <hidden point="mdDown">
        <div :class="{ hide: hide }" class="deco-inner">
          <div class="wave wave-one" />
          <div class="wave wave-two" />
        </div>
      </hidden>
      <div class="wave wave-cover" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./banner-style.scss";
</style>

<script>
// import youtube from '@/landing/youtube'
import imgAPI from "@/landing/static/images/imgAPI";
import link from "@/landing/static/text/link";
// import Hidden from '../Hidden'

export default {
  //   components: {
  //     Hidden
  //   },
  data() {
    return {
      videoId: "KxZAdEGpYAw",
      hide: false,
      link: link,
      imgAPI: imgAPI,
      dialog: false,
      player: null,
      playerVars: {
        autoplay: 0,
        controls: 1,
        rel: 0,
        showinfo: 1,
        mute: 0,
        origin: "https://localhost:8008",
      },
      //   yt: youtube
    };
  },
  methods: {
    handleVideoOpen() {
      //   if (!this.yt.use) {
      //     return false
      //   }
      this.dialog = true;
      setTimeout(() => {
        this.player = this.$refs.youtube.player;
        this.player.playVideo();
      }, 100);
    },
    handleVideoClose() {
      this.dialog = false;
      this.player.pauseVideo();
    },
  },
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
      //   const lgUp = this.$store.state.breakpoints.lgUp
      //   return lgUp.indexOf(this.$mq) > -1
    },
  },
};
</script>
